import BaseService from '@src/services/BaseService'

class CommercialService extends BaseService {
    constructor() {
    super('commercial')
    }
}

export default new CommercialService()
